<template>
  <v-container fill-height fluid>
    <v-layout justify-center wrap>
      <v-flex xs12 md4>
        <material-card class="v-card-profile">
          <v-avatar
            slot="offset"
            class="mx-auto d-block"
            size="130">
            <v-icon size="50" color="orange">mdi-account-star</v-icon>
          </v-avatar>
          <v-card-text class="text-xs-center">
            <h6 class="category text-gray font-weight-thin mb-3">{{employeeRole.vacation_days}} {{employeeRole.vacation_days == 1 ? $t('Common.day') : $t('Common.days')}}</h6>
            <h4 class="card-title">{{employeeRole.name}}</h4>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-layout column class="text-xs-center">
                  <label class="text-primary font-weight-thin mb-1">{{$t('Pages.EmployeeRoles.model.description')}}</label>
                  <p>{{employeeRole.description}}</p>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-btn color="warning" round class="font-weight-light" :to="'/employee-roles/' + employeeRole.id + '/update'">{{$t('Core.Fields.edit')}}</v-btn>
            <v-btn round class="font-weight-light" href="javascript:history.go(-1)">{{$t('Core.Fields.back')}}</v-btn>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
    import _ from 'lodash';
    export default {
        components: {},
        data: () => ({
            employeeRole: {},
        }),
        computed: {

        },
        created () {
            this.getEmployeeRole(this.$route.params.id);
        },
        methods: {
            getEmployeeRole(id){
                this.setFetching(true);
                this.repositories.employeeRole.get(id).then(response => {
                    this.employeeRole = response.data.data;
                }).finally(() => {
                    this.setFetching(false);
                });
            },
        }
    }
</script>
